import {
  postRequest,
  patchRequest,
  postFormDataRequest,
  getRequest,
  deleteRequest
} from "../lib/utils/request";

export const getAllAPI = async (
  apiHost,
  { limit, offset, sortField, sortDir },
  requestOptions
) => {
  return await getRequest(
    `${apiHost}/v1/users?limit=${limit}&offset=${offset}&sortField=${sortField}&sortDir=${sortDir}`,
    requestOptions
  );
};

export const getAPI = async (apiHost, { uid }, requestOptions) => {
  return await getRequest(`${apiHost}/v1/users/${uid}`, requestOptions);
};

export const deleteAPI = async (apiHost, { uid }, requestOptions) => {
  return await deleteRequest(`${apiHost}/v1/users/${uid}`, requestOptions);
};



// WEBPACK FOOTER //
// ./src/common/user/api.js